import React, { useState, useEffect } from "react";
import Axios from "../../_services/caller.service";
import styles from "./ConfigScheduler.module.scss";
import { toast } from "react-toastify";
import { PermissionGate } from "../superAdmin/managePermissions/PermissionGate";

const ConfigScheduler = () => {
  const [config, setConfig] = useState({
    intervalDays: 1,
    hour: 8,
    minute: 30,
    paused: false,
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  // Charger la configuration au montage du composant
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await Axios.get("/getConfig");
        console.log("Configuration reçue :", response.data.data);

        setConfig({
          intervalDays: response.data.data.intervalDays,
          hour: response.data.data.time.hour,
          minute: response.data.data.time.minute,
          paused: response.data.data.paused,
        });
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de la configuration :",
          error.message
        );
        setStatus("Erreur lors du chargement de la configuration.");
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfig((prevConfig) => ({
      ...prevConfig,
      [name]: parseInt(value, 10), // Convertir les valeurs en nombres
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Reformater les données avant de les envoyer
      const updatedConfig = {
        intervalDays: config.intervalDays,
        hour: config.hour,
        minute: config.minute,
        paused: config.paused,
      };
      console.log("Mise à jour de la configuration :", updatedConfig);

      const response = await Axios.post(
        "/reloadIntervalReminders",
        updatedConfig
      );
      toast.success(`Succès : ${response.data.message}`);
    } catch (error) {
      console.error(error);

      toast.error("Impossible de mettre à jour la configuration.");
    }
  };

  const togglePause = async () => {
    try {
      const updatedConfig = {
        ...config,
        paused: !config.paused,
      };
      console.log("Mise à jour de la configuration :", updatedConfig);

      const response = await Axios.post(
        "/reloadIntervalReminders",
        updatedConfig
      );
      setConfig(updatedConfig);
      setStatus(`Succès : ${response.data.message}`);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'état :", error.message);
      setStatus("Erreur : Impossible de mettre à jour l'état.");
    }
  };

  if (loading) return <p>Chargement...</p>;

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Configuration des rappels</h1>
      <PermissionGate actionKey={"manageCertificat.configScheduler.pause"}>
        <button
          onClick={togglePause}
          className={`${styles.button} ${config.paused ? styles.paused : ""}`}
        >
          {config.paused
            ? "Reprendre les rappels"
            : "Mettre les rappels en pause"}
        </button>
      </PermissionGate>
      <p className={styles.statusMessage}>
        {config.paused
          ? "Les rappels sont actuellement en pause. Reprenez-les pour configurer les intervalles."
          : "Les rappels sont actifs. Vous pouvez configurer les intervalles ci-dessous."}
      </p>

      <div
        className={`${styles.overlay} ${
          config.paused ? styles.activeOverlay : ""
        }`}
      >
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="intervalDays" className={styles.label}>
              Intervalle (jours) :
            </label>
            <input
              type="number"
              id="intervalDays"
              name="intervalDays"
              value={config.intervalDays}
              onChange={handleChange}
              min="1"
              className={styles.input}
              disabled={config.paused}
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="hour" className={styles.label}>
              Heure:
            </label>
            <input
              type="number"
              id="hour"
              name="hour"
              value={config.hour}
              onChange={handleChange}
              min="0"
              max="23"
              className={styles.input}
              disabled={config.paused}
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="minute" className={styles.label}>
              Minute:
            </label>
            <input
              type="number"
              id="minute"
              name="minute"
              value={config.minute}
              onChange={handleChange}
              min="0"
              max="59"
              className={styles.input}
              disabled={config.paused}
            />
          </div>

          {!config.paused && (
            <PermissionGate
              actionKey={"manageCertificat.configScheduler.updtate"}
            >
              <button type="submit" className={styles.submitButton}>
                Mettre à jour
              </button>
            </PermissionGate>
          )}
        </form>
      </div>
    </div>
  );
};

export default ConfigScheduler;
